import {
  CUSTOMER_LIST_REQUEST,
  CUSTOMER_LIST_SUCCESS,
  CUSTOMER_LIST_FAIL,
  CUSTOMER_TYPE_REQUEST,
  CUSTOMER_TYPE_SUCCESS,
  CUSTOMER_TYPE_FAIL,
  KARNATAKA_CITIES_REQUEST,
  KARNATAKA_CITIES_SUCCESS,
  KARNATAKA_CITIES_FAIL,
} from "../actionTypes";
import axiosInstance from "../../api/axiosInstance";
import { toast } from "react-toastify";

export const fetchCustomerList = (token) => async (dispatch) => {
  try {
    dispatch({ type: CUSTOMER_LIST_REQUEST });
    const response = await axiosInstance.get("/api/coupon-users-list/", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Customer List response:", response.data); // Check if the data is correct
    dispatch({ type: CUSTOMER_LIST_SUCCESS, payload: response.data });
    console.log(
      "Customer List data fetched successfully:........",
      response.data
    );
  } catch (error) {
    dispatch({
      type: CUSTOMER_LIST_FAIL,
      payload: error.response ? error.response.data : error.message,
    });
    console.log(
      "Customer List data fetch error:",
      error.response?.data || error.message
    );
  }
};
export const fetchCustomerTypes = (token) => async (dispatch) => {
  try {
    dispatch({ type: CUSTOMER_TYPE_REQUEST });
    // Add cache-busting parameter to prevent 304 responses
    const timestamp = new Date().getTime();
    const response = await axiosInstance.get("/api/get-customer-types/", {
      // params: {
      //   _t: timestamp, // Cache-busting parameter
      // },
      // headers: {
      //   Authorization: `Bearer ${token}`,
      //   'Cache-Control': 'no-cache',
      //   'Pragma': 'no-cache',
      // },
       headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Customer Types full response:", response);
    console.log("Customer Types response.data:", response.data);
    console.log("Customer Types response.data.data:", response.data.data);
    
    // Handle different response structures
    const customerTypesData = response.data?.data || response.data || [];
    console.log("Customer Types data to dispatch:", customerTypesData);
    
    dispatch({ type: CUSTOMER_TYPE_SUCCESS, payload: customerTypesData });
    console.log(
      "Customer Types data fetched successfully:",
      customerTypesData
    );
  } catch (error) {
    console.error("Customer Types fetch error:", error);
    dispatch({
      type: CUSTOMER_TYPE_FAIL,
      payload: error.response ? error.response.data : error.message,
    });
    console.log(
      "Customer Types data fetch error:",
      error.response?.data || error.message
    );
  }
};
export const fetchKarnatakaCities = (token) => async (dispatch) => {
  try {
    dispatch({ type: KARNATAKA_CITIES_REQUEST });
    const response = await axiosInstance.get("/api/karnataka-cities/", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
        console.log("Karnataka Cities response:", response.data);

    const citiesData = response.data?.cities || [];
    dispatch({ type: KARNATAKA_CITIES_SUCCESS, payload: citiesData });
  } catch (error) {
    console.error("Karnataka Cities fetch error:", error);
    dispatch({
      type: KARNATAKA_CITIES_FAIL,
      payload: error.response ? error.response.data : error.message,
    });
  }
};
// export const fetchCustomerTypes = () => async (dispatch) => {
//   try {
//     dispatch({ type: CUSTOMER_TYPE_REQUEST });
//     const { data } = await axiosInstance.get("/api/get-customer-types/");
//     dispatch({ type: CUSTOMER_TYPE_SUCCESS, payload: data });
//   } catch (error) {
//     console.log("Customer Types Error:", error.response?.data || error.message);
//     dispatch({
//       type: CUSTOMER_TYPE_FAIL,
//       payload: error.response?.data || error.message,
//     });
//     const errorMessage =
//       error.response?.data?.message || "Failed to fetch customer types.";
//     toast.error(errorMessage);
//   }
// };
